<script>
import {CREATE_SCHOOL} from "@/core/services/store/school-link-source/school-link-source.module";
import SchoolLinkForm from "@/view/pages/school-link-source/component/SchoolLinkForm.vue";

export default {
  name: "ModalAddSchool",
  components: {SchoolLinkForm},
  props: {
    provinces: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("Modal_Add_School");
    },
    resetForm() {
      this.$refs.schoolLinkForm?.resetForm();
    },
    confirmCreateSchool(payload) {
      this.loading = true;
      this.$store.dispatch(CREATE_SCHOOL, payload).then(() => {
        this.closeModal();
        this.$notify({
          title: "Thành công",
          message: "Thêm trường liên kết thành công",
          type: "success"
        });
        this.$emit("refreshData")
      }).catch(() => {
        this.$notify.error({
          title: "Đã có lỗi xảy ra",
          message: "Vui lòng thử lại"
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  },
}
</script>

<template>
  <b-modal id="Modal_Add_School" title="Thêm mới trường" centered hide-footer ref="Modal_Add_School"
           size="lg" @show="resetForm">
    <school-link-form
        ref="schoolLinkForm"
        :provinces="provinces"
        :loading="loading"
        submit-text="Thêm mới"
        cancel-text="Đóng"
        @submit="confirmCreateSchool"
        @cancel="closeModal"
    />
  </b-modal>
</template>

<style scoped>
</style>
